import React, { useEffect, useState, useRef } from "react";
import { slimImage } from "@/service/utils";
import { useStores } from "@/store";
import { useObserver } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import "./index.less";
import { getQuery } from "@/service/http";

/**
 * 收藏夹
 *
 * @returns
 */
const Favorite = ({ restaurant, track }) => {
  const { t } = useTranslation();
  const { memberStore, favoriteStore } = useStores();
  const [showCollection, setShowCollection] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [isSelected, setSelected] = useState(false);
  const [lock, setLock] = useState(false);
  const [collections, setCollections] = useState([]);
  const [collection, setCollection] = useState(null);
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("javascript:void(0);");
  const timerRef = useRef();

  function trigger() {
    track && track()
    const { private_token, login_url } = getQuery();
    if (!private_token) {
      window.top.location.href = login_url
      return;
    }
    if (isSelected) {
      return remove();
    }
    if (collections.length > 1) {
      return setShowCollection(true);
    }
    create(collection);
  }
  function remove() {
    if (!collection) return;
    if (lock) return;
    setLock(true);
    favoriteStore
      .remove(collection.id)
      .then(() => {
        setSelected(false);
        setMessage(t("WEB.Removed successfully"));
      })
      .catch((error) => {
        let msg = error.message;
        try {
          msg = error.full_messages[0];
        } catch (error) {}
        setMessage(msg);
      })
      .then(() => {
        setLock(false);
      });
  }

  function create(collection) {
    if (!collection) return;
    if (lock) return;
    setLock(true);
    favoriteStore
      .create(collection)
      .then(() => {
        setSelected(true);
        setMessage(t("WEB.Added successfully"));
      })
      .catch((error) => {
        let msg = error.message;
        try {
          msg = error.full_messages[0];
        } catch (error) {}
        setMessage(msg);
      })
      .then(() => {
        setLock(false);
      });
  }

  // 控制提示定时器
  useEffect(() => {
    clearTimeout(timerRef.current);
    if (!message) return;
    const timer = setTimeout(() => {
      clearTimeout(timer);
      setMessage("");
    }, 3000);
    timerRef.current = timer;
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [message]);

  useEffect(() => {
    if (!restaurant) return;
    const { private_token, login_url } = getQuery();
    // 如果已经登录
    if (private_token) {
      setLink(login_url);
      favoriteStore.setUrl(restaurant);
      favoriteStore.show().then(setCollection);
      favoriteStore.exist().then((exist) => {
        setSelected(exist);
        setShowButton(true);
      });
    } else {
      setShowButton(true);
      setLink("javascript:void(0);");
    }
  }, [restaurant]);

  return useObserver(() => {
    return (
      <div className="dc-favorite">
        <a
          className="favorite-button"
          data-selected={isSelected}
          onClick={trigger}
          hidden={!showButton}
        ></a>
        <div
          className="favorite-mask"
          hidden={!showCollection}
          onClick={() => setShowCollection(false)}
        ></div>
        <div className="favorite-collection" hidden={!showCollection}>
          <div className="favorite-header">Select collection</div>
          <div className="collection-list">
            {collections.map((item) => {
              return (
                <div
                  key={item.id}
                  className="favorite-item"
                  key={index}
                  onClick={() => create(item)}
                >
                  <div className="favorite-image">
                    <img src={slimImage(item.cover_url)} alt="" />
                  </div>
                  <div className="favorite-title">{item.title}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="favorite-notice" hidden={!message}>
          {message}
        </div>
      </div>
    );
  });
};

export default Favorite;
